<template>
  <div :class="classes">
    <div class="accordion__title" @click="onToggle">
      <m4-icon icon="angle-right"></m4-icon>
      <span v-if="title">{{ title }}</span>
      <span v-else><slot name="title"></slot></span>
    </div>
    <div class="accordion__body"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "M4Accordion",
  data() {
    return {
      isOpened: this.open,
      withOverflowHidden: !this.open
    };
  },
  props: {
    title: {
      type: String,
      required: false
    },
    open: {
      type: Boolean,
      required: false,
      default: false
    },
    size: String,
    variant: String,
    rounded: {
      type: Boolean,
      required: false,
      default: false
    },
    withBorder: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    classes() {
      let classes = ["accordion"];
      if (this.isOpened) {
        classes.push("accordion--is-opened");
      }
      if (this.size) {
        classes.push("accordion--" + this.size);
      }
      if (this.withOverflowHidden) {
        classes.push("accordion--of-hidden");
      }
      if (this.variant) {
        classes.push("accordion--" + this.variant);
      }
      if (this.rounded) {
        classes.push("accordion--rounded");
      }
      if (this.withBorder) {
        classes.push("accordion--with-border");
      }
      return classes;
    }
  },
  methods: {
    onToggle() {
      this.withOverflowHidden = true;
      this.isOpened = !this.isOpened;

      let self = this;
      setInterval(() => {
        self.withOverflowHidden = !this.isOpened;
      }, 300);
    }
  }
};
</script>
